import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLocking: false,
  isUnlocking: false,
  pendingCardId: null as string | null,
  error: null as string | null,
}

const bdmcLockUnlockSlice = createSlice({
  name: 'bdmcLockUnlock',
  initialState,
  reducers: {
    lockStart(state, action) {
      state.isLocking = true
      state.pendingCardId = action.payload
      state.error = null
    },
    lockSuccess(state) {
      state.isLocking = false
      state.pendingCardId = null
    },
    lockFailure(state, action) {
      state.isLocking = false
      state.pendingCardId = null
      state.error = action.payload
    },
    unlockStart(state, action) {
      state.isUnlocking = true
      state.pendingCardId = action.payload
      state.error = null
    },
    unlockSuccess(state) {
      state.isUnlocking = false
      state.pendingCardId = null
    },
    unlockFailure(state, action) {
      state.isUnlocking = false
      state.pendingCardId = null
      state.error = action.payload
    },
  },
})

export const selectBdmcIsLocking = (state: any) => state.bdmcLockUnlock.isLocking
export const selectBdmcIsUnlocking = (state: any) => state.bdmcLockUnlock.isUnlocking
export const selectBdmcLockPendingCardId = (state: any) => state.bdmcLockUnlock.pendingCardId
export const selectBdmcLockUnlockError = (state: any) => state.bdmcLockUnlock.error

export const {
  lockStart,
  lockSuccess,
  lockFailure,
  unlockStart,
  unlockSuccess,
  unlockFailure,
} = bdmcLockUnlockSlice.actions

export default bdmcLockUnlockSlice.reducer
